import { useTheme } from "@react-navigation/native";
import * as FileSystem from "expo-file-system";
import * as Sharing from "expo-sharing";
import { Button, Stack, Text } from "native-base";
import React from "react";
import { View } from "react-native";
import downloads from "../../common/downloads";
import ErrorToast from "../../components/ErrorToast";
import HeaderText from "../../components/HeaderText";
import ParagraphText from "../../components/ParagraphText";
import { isWeb } from "../../utils/utils";

const Accept = ({ setIsFormValid, isFormValid }) => {
	const { colors } = useTheme();

	const getFileUri = (name) => {
		return FileSystem.documentDirectory + `${encodeURI(name)}.pdf`;
	};

	const handleDownload = async (fileName) => {
		try {
			let file = await downloads(fileName);
			let base64 = file.data?.data?.base64_data;

			if (isWeb()) {
				downloadPDF(base64, fileName);
				return;
			}

			const fileUri = getFileUri(fileName);

			await FileSystem.writeAsStringAsync(fileUri, base64, {
				encoding: FileSystem.EncodingType.Base64,
			});
			await Sharing.shareAsync(fileUri);
		} catch (error) {
			ErrorToast(error.message);
		}
	};

	const downloadPDF = (pdf, fileName) => {
		const linkSource = `data:application/pdf;base64,${pdf}`;
		const downloadLink = document.createElement("a");

		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	};

	return (
		<View>
			<Stack mx="0.5" space={4}>
				<HeaderText>Accept Terms and Policies</HeaderText>
				<ParagraphText>
					In order to register as a participant of the Channel Incentive
					Programme it is required that your employment with a participating
					store is confirmed as well as the authenticity of your registration
					details.
				</ParagraphText>
				<ParagraphText>
					I agree that the following may be shared with the store manager of the
					store where I am employed at, staff members of manufacturer as well as
					the administrators of this program.
				</ParagraphText>

				<View style={{ padding: 5, marginLeft: 10 }}>
					<Text>1. Surname</Text>
					<Text>2. ID/Passport</Text>
					<Text>3.Uploaded Copy of ID Book/Passport</Text>
				</View>
				<View
					style={{
						flex: 1,
						flexDirection: "row",
						flexWrap: "wrap",
						alignItems: "center",
						margin: 4,
					}}
				>
					<Text>I also accept the </Text>
					<Button
						padding={0}
						onPress={() => handleDownload("terms-and-conditions")}
						size="md"
						variant="link"
					>
						Terms and Conditions,
					</Button>
					<Text> </Text>
					<Button
						padding={0}
						onPress={() => handleDownload("terms-of-use")}
						size="md"
						variant="link"
					>
						Website & App Terms of Use
					</Button>
					<Text> and </Text>
					<Button
						padding={0}
						onPress={() => handleDownload("privacy-policy")}
						size="md"
						variant="link"
					>
						Privacy Policy
					</Button>
					<Text> of the </Text>
					<Text> Channel </Text>
					<Text>Incentive </Text>
					<Text>Programme.</Text>
				</View>
				{isFormValid === false && (
					<Button
						onPress={() => setIsFormValid(true)}
						buttonStyle={{ marginRight: "auto", marginVertical: 10 }}
						style={{ marginRight: "auto" }}
						// bgColor={colors.primary}
					>
						Accept
					</Button>
				)}
			</Stack>
		</View>
	);
};

export default Accept;
